import React from 'react'
import { Wrapper, List, Item, Button, Icon, StyledLink, NoPageLink, SubList, SubItem, SubLink } from './styles.js'
import Expand from './../../images/expand.svg'

export class MobileNavigation extends React.Component {

    onClickHandler = (e) => {

        const el = document.querySelector(`#${e.currentTarget.id}-submenu`);
        
        if (el.classList.contains('open')) {
            el.classList.remove('open');
        } else {
            el.classList.add('open');
        }

    }
    
    render() {
        return (

            <Wrapper active={this.props.active}>
                
                <List theme='dark'>

                    <Item>
                        <NoPageLink className='no-page-link'>About us</NoPageLink>
                        <Button id='about' onClick={this.onClickHandler}>
                            <Icon src={Expand}></Icon>
                        </Button>
                        <SubList id='about-submenu'>
                            <SubItem>
                                <SubLink to='/about-us/company-history/'>Company History</SubLink>
                            </SubItem>
                            <SubItem>
                                <SubLink to='/about-us/leadership/'>Leadership</SubLink>
                            </SubItem>
                        </SubList>
                    </Item>

                    <Item>
                        <StyledLink to='/technology/' activeClassName='active'>Technology</StyledLink>
                        <Button id='technology' onClick={this.onClickHandler}>
                            <Icon src={Expand}></Icon>
                        </Button>
                        <SubList id='technology-submenu'>
                            <SubItem>
                                <SubLink to='/technology/nanogel-drug-delivery-platform/'>Nanogel Drug Delivery Platform</SubLink>
                            </SubItem>
                            <SubItem>
                                <SubLink to='/technology/nanogels-in-drug-development/'>Nanogels in Drug Development</SubLink>
                            </SubItem>
                        </SubList>
                    </Item>

                    <Item>
                        <StyledLink to='/therapeutic-applications/' activeClassName='active'>Therapeutic applications</StyledLink>
                    </Item>

                    <Item>
                        <NoPageLink className='no-page-link'>Partnering</NoPageLink>
                        <Button id='partnering' onClick={this.onClickHandler}>
                            <Icon src={Expand}></Icon>
                        </Button>
                        <SubList id='partnering-submenu'>
                            <SubItem>
                                <SubLink to='/partnering/partnership-opportunities/'>Partnership opportunities</SubLink>
                            </SubItem>
                            <SubItem>
                                <SubLink to='/partnering/projects/'>Projects</SubLink>
                            </SubItem>
                        </SubList>
                    </Item>

                    <Item>
                        <StyledLink to='/news/' activeClassName='active'>News</StyledLink>
                    </Item>

                    <Item>
                        <StyledLink to='/contact/' activeClassName='active'>Contact</StyledLink>
                    </Item>

                </List>

            </Wrapper>

        )
    }

}

export default MobileNavigation